// Capture UTM params on landing and persist them so they travel with the lead.
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_KEY = "pb_utm";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function captureUtmFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const captured = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) captured[k] = v;
    });
    if (Object.keys(captured).length === 0) return getStoredUtm();
    captured.ts = Date.now();
    captured.landing_path = window.location.pathname + window.location.hash;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
    return captured;
  } catch {
    return null;
  }
}

export function getStoredUtm() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (Date.now() - (data.ts || 0) > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function formatUtmForNotes(utm) {
  if (!utm) return "";
  const parts = UTM_KEYS.filter((k) => utm[k]).map((k) => `${k}=${utm[k]}`);
  return parts.length ? `[ad attribution: ${parts.join(", ")}]` : "";
}
